import { useEffect } from 'react';

import { setDocumentTitle } from '#/utils/meta/setDocumentTitle';

/**
 * @deprecated Use the `meta` function on the `.horizon-route` instead.
 *
 * Once we are on `horizon` using `meta` will be the standard way, as it supports SSR.
 */
export function useSetDocumentTitle(
  title: string | null | undefined,
  suffix?: string,
) {
  useEffect(() => {
    const isInStaffRoute =
      location.pathname.startsWith('/staff') ||
      location.pathname.startsWith('/cms');

    if (title)
      setDocumentTitle(
        isInStaffRoute ? '🧑‍💼 ' + title : title,
        suffix ?? (isInStaffRoute ? '' : 'Idealist'),
      );
  }, [suffix, title]);
}
